<script>
  import { Username,currentPasswordThrough, changePasswordThrough, SecurityAnswers } from "./store.js";
  import { onMount, createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  import Password from "../HTMLElements/PasswordSetter.svelte";
  import wrappedFetch from '../../wrappedfetch.js';

  let success = true;
  let info = "";
  let input = {value: '', isValid: false, isDirty: false, ref: null };
  let confirmInput = {value: '', isValid: false, isDirty: false, ref: null };
  let isLoading = false;

  onMount(async function() {
    if($Username.value == '' || $Username.value == undefined)
      dispatch('pageChange','/account/forgotpassword');
  });

  const createNewPassword = async e => {
    e.preventDefault();
    isLoading = true;

    var obj = {};
    obj.username = $Username.value;
    obj.password = input.value;
    obj.confirmPass = confirmInput.value;
    let resp;

    if($changePasswordThrough == 'securityQuestions'){
      obj.currentPassword = '';
      obj.answer1 = $SecurityAnswers[0].answer;
      obj.qRef1 = $SecurityAnswers[0].qRef;
      obj.answer2 = $SecurityAnswers[1].answer;
      obj.qRef2 = $SecurityAnswers[1].qRef;
      
      resp = await wrappedFetch('user/setpassword', {
        method: 'post',
        body: JSON.stringify(obj), 
         headers: {
           'Content-Type': 'application/json'
         }
      });
    }
    else {
      obj.currentPassword = $currentPasswordThrough
      resp = await wrappedFetch('user/changepassword', {
        method: 'post',
        body: JSON.stringify(obj), 
         headers: {
           'Content-Type': 'application/json'
         }
      });
    } 
    var changeResult = await resp.json();
    success = changeResult.success;
    info = changeResult.message;

    isLoading = false;
    if(success)
      dispatch('pageChange', '/account/passwordchangesuccess');
  };
</script>

<form class="box">
  <div class=" field">
    <a href="/account/selectedresetoption">
      <span class="fas fa-arrow-left info-icon" />
      Back
    </a>
  </div>
  <hr />
  <Password
    bind:password={input}
    bind:confirmPassword={confirmInput}
    showPolicy='true'
    isRequired='true' />
  <hr />

  {#if !success}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{info}</p>
    </div>
  {/if}

  <div style="text-align: right;">
    <button type="submit" class="button is-purple {isLoading ? 'is-loading' : ''}" on:click={createNewPassword} disabled={isLoading}>
      Save
    </button>
  </div>
</form>
